export default "__VITE_ASSET__CSeCShQ8__"